import React from 'react';
import '../template-file-css/document-file-template.css';



export const HFI_EapClinicalAssessment = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='HFI_EapClinicalAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>EAP CLINICAL ASSESSMENT</h3></center></p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Person Served:</span></td>
                        <td className='w-375'><span className='eleHeader'>Record Number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPersonServed' name='txtPersonServed' className='add-only'/></td>
                        <td className='w-375'>
                            <input type='text' id='txtRecordNumber' name='txtRecordNumber' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>EAP Auth Number: </span></td>
                        <td className='w-375'><span className='eleHeader'>Precipitating Event:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAuthNumber' name='txtAuthNumber' className='add-only'/></td>
                        <td className='w-375'>
                            <input type='text' id='txtPrecipitatingEvent' name='txtPrecipitatingEvent' className='add-only'/></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-450'><span className='eleHeader'>PSYCHOLOGICAL/EMOTIONAL SYMPTOMS and MENTAL STATUS</span></td>
                        <td className='w-300'><span className='eleHeader'>Organicity Indicators:</span></td>
                    </tr>
                    <tr>
                        <td className='w-450'>Current Signs and Symptoms:</td>
                        <td className='w-300'>Organicity Indicators:</td>
                    </tr>
                    <tr>
                        <td className='w-450'>0=None </td>
                        <td className='w-300'>Oriented x3 &nbsp;
                            <input type='radio' id='rbOriented_Yes' name='rbOriented' className='add-only' value='Yes'/> Yes &nbsp;
                            <input type='radio' id='rbOriented_No' name='rbOriented' className='add-only' value='No'/> No &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-450'>1=Mild </td>
                        <td className='w-300'>Impaired Memory&nbsp;
                            <input type='radio' id='rbImpairedMemory_Yes' name='rbImpairedMemory' className='add-only' value='Yes'/> Yes &nbsp;
                            <input type='radio' id='rbImpairedMemory_No' name='rbImpairedMemory' className='add-only' value='No'/> No &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-450'>2=Moderate</td>
                        <td className='w-300'> Other Cognitive Impairment&nbsp;
                            <input type='radio' id='rbOtherCognitiveImpairment_Yes' name='rbOtherCognitiveImpairment' className='add-only' value='Yes'/> Yes &nbsp;
                            <input type='radio' id='rbOtherCognitiveImpairment_No' name='rbOtherCognitiveImpairment' className='add-only' value='No'/> No &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-450'>3=Severe</td>
                        <td className='w-300'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-350'>
                            <span className='eleHeader'>&nbsp;</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'><center><b>0</b></center></span></td>
                        <td className='w-100'>
                            <span className='eleHeader'><center><b>1</b></center></span></td>
                        <td className='w-100'>
                            <span className='eleHeader'><center><b>2</b></center></span></td>
                        <td className='w-100'>
                            <span className='eleHeader'><center><b>3</b></center></span></td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-350'>Depressed Mood</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDepressed_1' name='rbDepressed' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDepressed_2' name='rbDepressed' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDepressed_3' name='rbDepressed' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDepressed_4' name='rbDepressed' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Appetite Disturbance</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAppetiteDisturbance_1' name='rbAppetiteDisturbance' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAppetiteDisturbance_2' name='rbAppetiteDisturbance' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAppetiteDisturbance_3' name='rbAppetiteDisturbance' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAppetiteDisturbance_4' name='rbAppetiteDisturbance' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Sleep Disturbance</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSleepDisturbance_1' name='rbSleepDisturbance' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSleepDisturbance_2' name='rbSleepDisturbance' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSleepDisturbance_3' name='rbSleepDisturbance' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSleepDisturbance_4' name='rbSleepDisturbance' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Elimination Disturbance</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbEliminationDisturbance_1' name='rbEliminationDisturbance' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbEliminationDisturbance_2' name='rbEliminationDisturbance' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbEliminationDisturbance_3' name='rbEliminationDisturbance' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbEliminationDisturbance_4' name='rbEliminationDisturbance' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Low Energy</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLowEnergy_1' name='rbLowEnergy' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLowEnergy_2' name='rbLowEnergy' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLowEnergy_3' name='rbLowEnergy' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLowEnergy_4' name='rbLowEnergy' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Psychomotor Retardation</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPsychomotorRetardation_1' name='rbPsychomotorRetardation' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPsychomotorRetardation_2' name='rbPsychomotorRetardation' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPsychomotorRetardation_3' name='rbPsychomotorRetardation' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPsychomotorRetardation_4' name='rbPsychomotorRetardation' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Agitation</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAgitation_1' name='rbAgitation' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAgitation_2' name='rbAgitation' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAgitation_3' name='rbAgitation' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAgitation_4' name='rbAgitation' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Lability</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLability_1' name='rbLability' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLability_2' name='rbLability' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLability_3' name='rbLability' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLability_4' name='rbLability' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Irritability </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbIrritability_1' name='rbIrritability' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbIrritability_2' name='rbIrritability' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbIrritability_3' name='rbIrritability' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbIrritability_4' name='rbIrritability' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Generalized Anxiety</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbGeneralizedAnxiety_1' name='rbGeneralizedAnxiety' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbGeneralizedAnxiety_2' name='rbGeneralizedAnxiety' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbGeneralizedAnxiety_3' name='rbGeneralizedAnxiety' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbGeneralizedAnxiety_4' name='rbGeneralizedAnxiety' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Panic Attacks</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPanicAttacks_1' name='rbPanicAttacks' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPanicAttacks_2' name='rbPanicAttacks' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPanicAttacks_3' name='rbPanicAttacks' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPanicAttacks_4' name='rbPanicAttacks' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Phobias</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPhobias_1' name='rbPhobias' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPhobias_2' name='rbPhobias' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPhobias_3' name='rbPhobias' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPhobias_4' name='rbPhobias' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Obsessions/Compulsions</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbObsessionsCompulsions_1' name='rbObsessionsCompulsions' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbObsessionsCompulsions_2' name='rbObsessionsCompulsions' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbObsessionsCompulsions_3' name='rbObsessionsCompulsions' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbObsessionsCompulsions_4' name='rbObsessionsCompulsions' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Binging/Purging</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbBingingPurging_1' name='rbBingingPurging' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbBingingPurging_2' name='rbBingingPurging' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbBingingPurging_3' name='rbBingingPurging' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbBingingPurging_4' name='rbBingingPurging' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Anorexia</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAnorexia_1' name='rbAnorexia' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAnorexia_2' name='rbAnorexia' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAnorexia_3' name='rbAnorexia' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAnorexia_4' name='rbAnorexia' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Paranoid Ideation</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbParanoidIdeation_1' name='rbParanoidIdeation' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbParanoidIdeation_2' name='rbParanoidIdeation' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbParanoidIdeation_3' name='rbParanoidIdeation' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbParanoidIdeation_4' name='rbParanoidIdeation' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Circumstantial/Tangential</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCircumstantialTangential_1' name='rbCircumstantialTangential' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCircumstantialTangential_2' name='rbCircumstantialTangential' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCircumstantialTangential_3' name='rbCircumstantialTangential' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCircumstantialTangential_4' name='rbCircumstantialTangential' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Loose Associations</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLooseAssociations_1' name='rbLooseAssociations' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLooseAssociations_2' name='rbLooseAssociations' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLooseAssociations_3' name='rbLooseAssociations' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLooseAssociations_4' name='rbLooseAssociations' className='add-only' value='4'/></center></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-350'>
                            <span className='eleHeader'>Specify:</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'><center><b>0</b></center></span></td>
                        <td className='w-100'>
                            <span className='eleHeader'><center><b>1</b></center></span></td>
                        <td className='w-100'>
                            <span className='eleHeader'><center><b>2</b></center></span></td>
                        <td className='w-100'>
                            <span className='eleHeader'><center><b>3</b></center></span></td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-350'>Delusions</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDelusions_1' name='rbDelusions' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDelusions_2' name='rbDelusions' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDelusions_3' name='rbDelusions' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDelusions_4' name='rbDelusions' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Hallucinations</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHallucinations_1' name='rbHallucinations' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHallucinations_2' name='rbHallucinations' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHallucinations_3' name='rbHallucinations' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHallucinations_4' name='rbHallucinations' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Aggressive Behaviors</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAggressiveBehaviors_1' name='rbAggressiveBehaviors' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAggressiveBehaviors_2' name='rbAggressiveBehaviors' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAggressiveBehaviors_3' name='rbAggressiveBehaviors' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAggressiveBehaviors_4' name='rbAggressiveBehaviors' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Conduct Problems</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbConductProblems_1' name='rbConductProblems' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbConductProblems_2' name='rbConductProblems' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbConductProblems_3' name='rbConductProblems' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbConductProblems_4' name='rbConductProblems' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Oppositional Behavior</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOppositionalBehavior_1' name='rbOppositionalBehavior' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOppositionalBehavior_2' name='rbOppositionalBehavior' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOppositionalBehavior_3' name='rbOppositionalBehavior' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOppositionalBehavior_4' name='rbOppositionalBehavior' className='add-only' value='4'/></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Sexual Dysfunction</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSexualDysfunction_1' name='rbSexualDysfunction' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSexualDysfunction_2' name='rbSexualDysfunction' className='add-only' value='2'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSexualDysfunction_3' name='rbSexualDysfunction' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSexualDysfunction_4' name='rbSexualDysfunction' className='add-only' value='4'/></center></td>
                    </tr>
                </table>

                <p className='w-750'><b>RISK ASSESSMENT</b> Check any risk that has occurred in the past three (3) months. Elaborate on any positive findings</p>


                <table>
                    <tr>
                        <td className='w-100'>
                            <span className='eleHeader'><center>Severity <br />&nbsp;</center></span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'><center>Suicidal Risk</center></span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'><center>Homicidal Risk</center></span>
                        </td>
                        <td className='w-225'>
                            <span className='eleHeader'><center>Abuse: physical/sexual <br />&nbsp;</center></span>
                        </td>
                        <td className='w-225'>
                            <span className='eleHeader'><center>Domestic Violence <br />&nbsp;</center></span>
                        </td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>

                        <td className='w-100'>&nbsp;</td>
                        <td className='w-100'>&nbsp;</td>
                        <td className='w-100'>&nbsp;</td>
                        <td className='w-225'>
                            <center><input type='radio' id='rbAbuse_1' name='rbAbuse' className='add-only' value='1'/> Victim &nbsp;
                                <input type='radio' id='rbAbuse_2' name='rbAbuse' className='add-only' value='2'/> Perpetrator </center>
                        </td>
                        <td className='w-225'>
                            <center><input type='radio' id='rbDomestic_1' name='rbDomestic' className='add-only' value='1'/> Victim &nbsp;
                                <input type='radio' id='rbDomestic_2' name='rbDomestic' className='add-only' value='2'/> Perpetrator </center>

                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <center>0</center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNone_1' name='rbNone' className='add-only' value='1'/> None</center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNone_2' name='rbNone' className='add-only' value='2'/> None</center></td>
                        <td className='w-225'>
                            <center><input type='radio' id='rbNone_3' name='rbNone' className='add-only' value='3'/> None</center></td>
                        <td className='w-225'>
                            <center><input type='radio' id='rbNone_4' name='rbNone' className='add-only' value='4'/> None</center></td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <center>1</center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbIdeation_1' name='rbIdeation' className='add-only' value='1'/> Ideation D</center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbIdeation_2' name='rbIdeation' className='add-only' value='2'/> Ideation</center></td>
                        <td className='w-225'>
                            <center><input type='radio' id='rbIdeation_3' name='rbIdeation' className='add-only' value='3'/> Ideation</center></td>
                        <td className='w-225'>
                            <center><input type='radio' id='rbIdeation_4' name='rbIdeation' className='add-only' value='4'/> Verbal Abuse D</center></td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <center>2</center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbIntent_1' name='rbIntent' className='add-only' value='1'/> Intent D</center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbIntent_2' name='rbIntent' className='add-only' value='2'/> Intent</center></td>
                        <td className='w-225'>
                            <center><input type='radio' id='rbIntent_3' name='rbIntent' className='add-only' value='3'/> Intent</center></td>
                        <td className='w-225'>
                            <center><input type='radio' id='rbIntent_4' name='rbIntent' className='add-only' value='4'/> Emotional Abuse D</center></td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <center>3</center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPlan_1' name='rbPlan' className='add-only' value='1'/> Plan D</center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPlan_2' name='rbPlan' className='add-only' value='2'/> Plan</center></td>
                        <td className='w-225'>
                            <center><input type='radio' id='rbPlan_3' name='rbPlan' className='add-only' value='3'/> Plan</center></td>
                        <td className='w-225'>
                            <center><input type='radio' id='rbPlan_4' name='rbPlan' className='add-only' value='4'/> Physical/sexual abuse</center></td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <center>4</center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMeans_1' name='rbMeans' className='add-only' value='1'/> Means D*</center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMeans_2' name='rbMeans' className='add-only' value='2'/> Means*</center></td>
                        <td className='w-225'>
                            <center><input type='radio' id='rbMeans_3' name='rbMeans' className='add-only' value='3'/> Means*</center></td>
                        <td className='w-225'>
                            <center><input type='radio' id='rbMeans_4' name='rbMeans' className='add-only' value='4'/> Medical attention / ER</center></td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <center>5</center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAttempt_1' name='rbAttempt' className='add-only' value='1'/> Attempt D</center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAttempt_2' name='rbAttempt' className='add-only' value='2'/> Attempt</center></td>
                        <td className='w-225'>
                            <center><input type='radio' id='rbAttempt_3' name='rbAttempt' className='add-only' value='3'/> Attempt</center></td>
                        <td className='w-225'>
                            <center><input type='radio' id='rbAttempt_4' name='rbAttempt' className='add-only' value='4'/> Life threatening D</center></td>
                    </tr>

                </table>






                <table>
                    <tr>
                        <td className='w-375'><b>*</b> Includes access to guns(weapons)</td>
                        <td className='w-375'><b>D</b> Complete Depression screening and results</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Threat of Violence (TOV) Level: </span>
                            <span className='small'>Check applicable level. Levels 3-5 contact EAP Consultant within 48 hours</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbThreatOfViolence_1' name='rbThreatOfViolence' className='add-only' value='5'/> 1- Assessed; no indicators</td>
                        <td className='w-375'>
                            <input type='radio' id='rbThreatOfViolence_2' name='rbThreatOfViolence' className='add-only' value='5'/> 2- Possible threat mentioned; no current danger</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbThreatOfViolence_3' name='rbThreatOfViolence' className='add-only' value='5'/> 3- Threat made; possibility of violent action exits</td>
                        <td className='w-375'>
                            <input type='radio' id='rbThreatOfViolence_4' name='rbThreatOfViolence' className='add-only' value='5'/> 4- Active threat of violence exists</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbThreatOfViolence_5' name='rbThreatOfViolence' className='add-only' value='5'/> 5- Person served is dangers to self/others</td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Comments:</span>
                    <input type='text' id='txtComments' name='txtComments' className='add-only'/>
                </p>

                <p className='w-750'><span className='eleHeader'>ENVIRONMENTAL, HOME, AND WORK SITUATION; SOCIAL AND PEER SUPPORTS:</span>
                    <textarea id='txtEnvironmentalHomeWork' name='txtEnvironmentalHomeWork' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>RELATIVE SOCIAL HISTORY:</span>
                    <textarea id='txtRelativeSocialHistory' name='txtRelativeSocialHistory' className='add-only'></textarea>
                </p>


                <p className='w-750'><h4>SUBSTANCE USE/ABUSE HISTORY</h4>
                    <span>(complete for all age 12 and over)</span></p>

                <table>
                    <tr>
                        <td className='w-200'><span className='eleHeader'>Substance</span></td>
                        <td className='w-110'><span className='eleHeader'>Amount</span></td>
                        <td className='w-110'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-110'><span className='eleHeader'>Duration</span></td>
                        <td className='w-110'><span className='eleHeader'>First Use</span></td>
                        <td className='w-110'><span className='eleHeader'>Last Use</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'>Caffeine</td>
                        <td className='w-110'>
                            <input type='text' id='txtCaffeine_1' name='txtCaffeine_1' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtCaffeine_2' name='txtCaffeine_2' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtCaffeine_3' name='txtCaffeine_3' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtCaffeine_4' name='txtCaffeine_4' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtCaffeine_5' name='txtCaffeine_5' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-200'>Tobacco</td>
                        <td className='w-110'>
                            <input type='text' id='txtTobacco_1' name='txtTobacco_1' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtTobacco_2' name='txtTobacco_2' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtTobacco_3' name='txtTobacco_3' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtTobacco_4' name='txtTobacco_4' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtTobacco_5' name='txtTobacco_5' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-200'>Alcohol</td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohol_1' name='txtAlcohol_1' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohol_2' name='txtAlcohol_2' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohol_3' name='txtAlcohol_3' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohol_4' name='txtAlcohol_4' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohol_5' name='txtAlcohol_5' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-200'>Marijuana</td>
                        <td className='w-110'>
                            <input type='text' id='txtMarijuana_1' name='txtMarijuana_1' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtMarijuana_2' name='txtMarijuana_2' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtMarijuana_3' name='txtMarijuana_3' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtMarijuana_4' name='txtMarijuana_4' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtMarijuana_5' name='txtMarijuana_5' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-200'>Opioids/Narcotics</td>
                        <td className='w-110'>
                            <input type='text' id='txtOpioidsNarcotics_1' name='txtOpioidsNarcotics_1' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtOpioidsNarcotics_2' name='txtOpioidsNarcotics_2' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtOpioidsNarcotics_3' name='txtOpioidsNarcotics_3' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtOpioidsNarcotics_4' name='txtOpioidsNarcotics_4' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtOpioidsNarcotics_5' name='txtOpioidsNarcotics_5' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-200'>Amphetamines</td>
                        <td className='w-110'>
                            <input type='text' id='txtAmphetamines_1' name='txtAmphetamines_1' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtAmphetamines_2' name='txtAmphetamines_2' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtAmphetamines_3' name='txtAmphetamines_3' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtAmphetamines_4' name='txtAmphetamines_4' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtAmphetamines_5' name='txtAmphetamines_5' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-200'>Cocaine</td>
                        <td className='w-110'>
                            <input type='text' id='txtCocaine_1' name='txtCocaine_1' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtCocaine_2' name='txtCocaine_2' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtCocaine_3' name='txtCocaine_3' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtCocaine_4' name='txtCocaine_4' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtCocaine_5' name='txtCocaine_5' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-200'>Hallucinogens</td>
                        <td className='w-110'>
                            <input type='text' id='txtHallucinogens_1' name='txtHallucinogens_1' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtHallucinogens_2' name='txtHallucinogens_2' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtHallucinogens_3' name='txtHallucinogens_3' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtHallucinogens_4' name='txtHallucinogens_4' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtHallucinogens_5' name='txtHallucinogens_5' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-200'>Others:</td>
                        <td className='w-110'>
                            <input type='text' id='txtOthers_1' name='txtOthers_1' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtOthers_2' name='txtOthers_2' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtOthers_3' name='txtOthers_3' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtOthers_4' name='txtOthers_4' className='add-only'/></td>
                        <td className='w-110'>
                            <input type='text' id='txtOthers_5' name='txtOthers_5' className='add-only'/></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>FAMILY HISTORY OF CHEMICAL DEPENENCE/SUBSTANCE ABUSE OR MENTAL ILLNESS:</span>
                    <textarea id='txtFamilyHistoryOfChemical' name='txtFamilyHistoryOfChemical' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>PREVIOUS TREATMENT HISTORY:</h4></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>LAST VISIT TO MD:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>DATE:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtLastVisit' name='txtLastVisit' className='add-only'/></td>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only'/></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>CURRENT MEDICAL CONDITIONS:</span>
                    <input type='text' id='txtCurrentMedicalConditions' name='txtCurrentMedicalConditions' className='add-only'/>
                </p>

                <p className='w-750'><span className='eleHeader'>CURRENT MEDICATIONS:</span>
                    <input type='text' id='txtCurrentMedications' name='txtCurrentMedications' className='add-only'/>
                </p>
                

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>DETERIORATION IN JOB / SCHOOL PERFORMANCE DUE TO THE PROBLEM:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbDeterioration_1' name='rbDeterioration' className='add-only' value='1'/> Attendance</td>
                        <td className='w-187'>
                            <input type='radio' id='rbDeterioration_2' name='rbDeterioration' className='add-only' value='2'/> Erratic behavior </td>
                        <td className='w-187'>
                            <input type='radio' id='rbDeterioration_3' name='rbDeterioration' className='add-only' value='3'/> Discipline</td>
                        <td className='w-187'>
                            <input type='radio' id='rbDeterioration_4' name='rbDeterioration' className='add-only' value='4'/> Conflict with supervisor  </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbDeterioration_5' name='rbDeterioration' className='add-only' value='5'/> Decrease in productivity</td>
                        <td className='w-250'>
                            <input type='radio' id='rbDeterioration_6' name='rbDeterioration' className='add-only' value='6'/> Accidents / Safety Violations</td>
                        <td className='w-250'>
                            <input type='radio' id='rbDeterioration_7' name='rbDeterioration' className='add-only' value='7'/> Conflicts with fellow employees</td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbDeterioration_8' name='rbDeterioration' className='add-only' value='8'/> None
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-275'>
                            <span className='eleHeader'>STRENGTHS / LIMITATIONS</span></td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>Present</span></center></td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>Absent</span></center></td>
                        <td className='w-275'>
                            <center><span className='eleHeader'>Notes:</span></center></td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                            1. Bright, learns quickly</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbBrightLearns_1' name='rbBrightLearns' className='add-only' value='1'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbBrightLearns_2' name='rbBrightLearns' className='add-only' value='2'/></center></td>
                        <td className='w-275'>
                            <input type='text' id='txtNote_1' name='txtNote_1' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                            2. Insightful/Self aware</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbInsightFulSelfAware_1' name='rbInsightFulSelfAware' className='add-only' value='3'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbInsightFulSelfAware_2' name='rbInsightFulSelfAware' className='add-only' value='4'/></center></td>
                        <td className='w-275'>
                            <input type='text' id='txtNote_2' name='txtNote_2' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                            3. Relates well to others</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbRelatesWell_1' name='rbRelatesWell' className='add-only' value='5'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbRelatesWell_2' name='rbRelatesWell' className='add-only' value='6'/></center></td>
                        <td className='w-275'>
                            <input type='text' id='txtNote_3' name='txtNote_3' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                            4. Good social support system</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbGoodSocialSupport_1' name='rbGoodSocialSupport' className='add-only' value='7'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbGoodSocialSupport_2' name='rbGoodSocialSupport' className='add-only' value='8'/></center></td>
                        <td className='w-275'>
                            <input type='text' id='txtNote_4' name='txtNote_4' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                            5. Satisfied w/job</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSatisfiedJob_1' name='rbSatisfiedJob' className='add-only' value='9'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSatisfiedJob_2' name='rbSatisfiedJob' className='add-only' value='10'/></center></td>
                        <td className='w-275'>
                            <input type='text' id='txtNote_5' name='txtNote_5' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                            6. Satisfied w/job performance</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSatisfiedJobPerformance_1' name='rbSatisfiedJobPerformance' className='add-only' value='11'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSatisfiedJobPerformance_2' name='rbSatisfiedJobPerformance' className='add-only' value='12'/></center></td>
                        <td className='w-275'>
                            <input type='text' id='txtNote_6' name='txtNote_6' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                            7. Hobbies or recreational activity</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHobbiesRecreationalActivity_1' name='rbHobbiesRecreationalActivity' className='add-only' value='13'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHobbiesRecreationalActivity_2' name='rbHobbiesRecreationalActivity' className='add-only' value='14'/></center></td>
                        <td className='w-275'>
                            <input type='text' id='txtNote_7' name='txtNote_7' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                            8. Marital/Relationship satisfaction</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMaritalRelationship_1' name='rbMaritalRelationship' className='add-only' value='15'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMaritalRelationship_2' name='rbMaritalRelationship' className='add-only' value='16'/></center></td>
                        <td className='w-275'>
                            <input type='text' id='txtNote_8' name='txtNote_8' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                            9. Motivated to change</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMotivatedToChange_1' name='rbMotivatedToChange' className='add-only' value='17'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMotivatedToChange_2' name='rbMotivatedToChange' className='add-only' value='18'/></center></td>
                        <td className='w-275'>
                            <input type='text' id='txtNote_9' name='txtNote_9' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                        10. Cultural /Community Involvement</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCulturalCommunity_1' name='rbCulturalCommunity' className='add-only' value='19'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCulturalCommunity_2' name='rbCulturalCommunity' className='add-only' value='20'/></center></td>
                        <td className='w-275'>
                            <input type='text' id='txtNote_10' name='txtNote_10' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                        11. Spiritual Focus</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSpiritualFocus_1' name='rbSpiritualFocus' className='add-only' value='21'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSpiritualFocus_2' name='rbSpiritualFocus' className='add-only' value='22'/></center></td>
                        <td className='w-275'>
                            <input type='text' id='txtNote_11' name='txtNote_11' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                        12. Special needs</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSpecialNeeds_1' name='rbSpecialNeeds' className='add-only' value='23'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSpecialNeeds_2' name='rbSpecialNeeds' className='add-only' value='24'/></center></td>
                        <td className='w-275'>
                            <input type='text' id='txtNote_11' name='txtNote_11' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                        13. Other </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOther_1' name='rbOther' className='add-only' value='25'/></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOther_2' name='rbOther' className='add-only' value='26'/></center></td>
                        <td className='w-275'>
                            <input type='text' id='txtNote_11' name='txtNote_11' className='add-only'/></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>INTERESTS, SKILLS AND APTITUDES:</span>
                <textarea id='txtInterestsSkillsAnd' name='txtInterestsSkillsAnd' className='add-only'></textarea>
                </p>
                
                <p className='w-750'><span className='eleHeader'>PROVISIONAL CLINICAL DIAGNOSIS AND EVALUATION</span>
                <span className='small'>Please include both MH/SUD diagnosis and physical health disorders</span>
                <textarea id='txtProvisionalClinicalAnd' name='txtProvisionalClinicalAnd' className='add-only'></textarea>
                </p>



            </div>
        </form >

    )
}  
